var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01617e-06 7.58374C-0.00051163 7.32715 0.0971187 7.0704 0.292893 6.87462L6.87462 0.292893C7.26514 -0.0976313 7.89831 -0.0976309 8.28883 0.292893C8.67936 0.683418 8.67936 1.31658 8.28883 1.70711L3.41018 6.58576H16.1302C16.6825 6.58576 17.1312 7.03347 17.1312 7.58576L17.1312 21.5858C17.1312 22.138 16.6835 22.5858 16.1312 22.5858C15.5789 22.5858 15.1312 22.138 15.1312 21.5858L15.1312 8.58576H3.41421L8.28883 13.4604C8.67936 13.8509 8.67936 14.4841 8.28883 14.8746C7.89831 15.2651 7.26514 15.2651 6.87462 14.8746L0.292893 8.29286C0.0971187 8.09709 -0.000511631 7.84034 2.01617e-06 7.58374Z",
    fill: "#1F202F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.f8b0ee53369a31e1da8ffc4a4cc0e2e3.svg";
export { ForwardRef as ReactComponent };